import { createAction, props } from "@ngrx/store";
import { Notification } from "../../notification";

/* NgRx */

export const showNotification = createAction(
  "[Notification] Show",
  props<{ notification: Notification }>()
);

export const showNotificationSuccess = createAction(
  "[Notification] Show Success",
  props<{ notification: Notification }>()
);

export const showNotificationFailure = createAction(
  "[Notification] Show Fail",
  props<{ error: string }>()
);
